@file:OptIn(InternalResourceApi::class)

package portfolio.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portfolio.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_788_909_708)
internal val Res.drawable.email: DrawableResource by lazy {
      DrawableResource("drawable:email", setOf(
        ResourceItem(setOf(), "${MD}drawable/email.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(34_071_315)
internal val Res.drawable.github: DrawableResource by lazy {
      DrawableResource("drawable:github", setOf(
        ResourceItem(setOf(), "${MD}drawable/github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-739_683_966)
internal val Res.drawable.linkedin: DrawableResource by lazy {
      DrawableResource("drawable:linkedin", setOf(
        ResourceItem(setOf(), "${MD}drawable/linkedin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-807_107_395)
internal val Res.drawable.profile: DrawableResource by lazy {
      DrawableResource("drawable:profile", setOf(
        ResourceItem(setOf(), "${MD}drawable/profile.jpeg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("email", Res.drawable.email)
  map.put("github", Res.drawable.github)
  map.put("linkedin", Res.drawable.linkedin)
  map.put("profile", Res.drawable.profile)
}
